import { Moment } from 'moment';

import { FileLink } from '../file-link.model';
import { FocusRange } from '../focus-range.model';
import { ConversationalTheme } from '../types/conversational-theme';
import { ThreadStatus } from '../types/thread-status';
import { User } from '../user.model';

import { Comment, Commentable } from './comment.model';

/**
 * Model for API TimelineThreadReply Model
 */
export class Thread implements Commentable {
  /**
   * Auto-generated identifier.
   */
  id: number;

  /**
   * Author, based on API CustomerContact model
   */
  author: User;

  /**
   * Title of the thread (only for private ones)
   */
  title: string;

  /**
   * Date of creation of the thread.
   */
  createdAt: Moment;

  /**
   * Date of update of the thread.
   */
  updatedAt: Moment;

  /**
   * Reading status of the thread.
   */
  readStatus: ThreadStatus;

  /**
   * The content of the thread.
   */
  body = '';

  /**
   * Whether this thread has been set as important.
   */
  starred = false;

  /**
   * Whether this thread is private.
   */
  privateThread = false;

  /**
   * The subject of the thread
   */
  themes: ConversationalTheme[];

  /**
   * List of replies to the thread.
   */
  comments: Comment[];

  /**
   * List of focus subjects that are associated to the thread.
   */
  focusList: FocusRange[];

  /**
   * List of binary files attached to thread, only 1 for now
   */
  files: File[];

  /**
   * List of summary of files attached to thread
   */
  links: FileLink[];

  /**
   * List of users directly concerned by the thread
   */
  users: User[] = [];

  constructor(attributes: Partial<Thread> = {}) {
    Object.assign(this, attributes);
  }

  getAllUsers(field?: string): User[] {
    const users = [this.author].concat(this.users);
    return field ? users.map((user: User) => user[field]) : users;
  }

  getLastActivity(): Moment {
    return this.comments.length ? this.comments[this.comments.length - 1].createdAt : this.createdAt;
  }
}
